import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUser, isLoggedIn } from "../api/auth";

// Routes a signed-in user who has no WhatsApp number to /complete-profile.
//
// Sits inside the Router next to SessionGuard, for the same reason: it reads
// the current URL and pushes history rather than reloading the document.
//
// Only these paths are exempt. Everything else is behind the number, which is
// what makes Google sign-up stop being a way around the requirement.
const EXEMPT = [
  "/complete-profile",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
];

const ProfileGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn()) return;
    if (EXEMPT.some((p) => location.pathname.startsWith(p))) return;

    const user = getUser();
    // Undefined means a session stored before this flag existed. Those users
    // are left alone until their next login, which refreshes the stored user
    // from the server — guessing "needs a phone" from a missing field would
    // send people who already gave one to a screen they cannot complete.
    if (!user || user.needsPhone !== true) return;

    // Carries where they were going, so they land there after supplying it
    // rather than on a generic page.
    const next = encodeURIComponent(location.pathname + location.search);
    navigate(`/complete-profile?next=${next}`, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default ProfileGuard;
